module.exports = ".mgr-20{\r\n    margin-right : 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2123-ydivision1/ydivision1.component.css
// module id = ./src/app/a2123-ydivision1/ydivision1.component.css
// module chunks = main